import {
  StatusBarSettingsState,
  StatusSettingsType,
  SET_SETTINGS_INITIAL_LOCATION,
  SET_SETTINGS_OPEN_STATE,
  SET_PHONESWITCH_OPEN_STATE
} from "./types"

const initialStatelocation: StatusBarSettingsState = {
  initialLocation: "",
  isOpen: false,
  PhoneSwitchOpen: false
}

export default Object.freeze(function statusBarSettingsReducer(
  state = initialStatelocation,
  action: StatusSettingsType
): StatusBarSettingsState {
  switch (action.type) {
    case SET_SETTINGS_INITIAL_LOCATION:
      return {
        ...state,
        initialLocation: action.payload
      }
    case SET_SETTINGS_OPEN_STATE:
      return {
        ...state,
        isOpen: action.isOpen
      }
    case SET_PHONESWITCH_OPEN_STATE:
      return {
        ...state,
        PhoneSwitchOpen: action.PhoneSwitchOpen
      }
    default:
      return state
  }
})
